import React, { useCallback } from 'react'

import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { RecipeTile } from '@features/recipe-tile'
import { MenuApiPreferencesResponse, RecipeUUID } from '@library/menu-service'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'
import { useCurrentCollectionId } from 'hooks/menu-collections'
import { useMenuMeta } from 'hooks/menu-metadata/useMenuMeta'
import { useRecipe } from 'hooks/menu-recipes/useRecipe'
import { showDetailRecipe } from 'routes/Menu/actions/menuRecipeDetails'
import { useBasket } from 'routes/Menu/domains/basket'
import { useSetBrowserCTAVisibility } from 'routes/Menu/domains/menu'

type RecipeGroupingRecipeProps = {
  id: RecipeUUID
  menuPreferences?: MenuApiPreferencesResponse
}

const Slide = withCitrusTheme(Box, (theme) => ({
  width: 'calc(33.33% - 1.4rem)',

  [`@media (max-width: ${theme.tokens.breakpoints[0]})`]: {
    width: '100%',
  },
}))

export const RecipeGroupingRecipe = ({ id, menuPreferences }: RecipeGroupingRecipeProps) => {
  const { basketHasRecipe } = useBasketRecipes()
  const { canAddRecipes, addRecipe, removeRecipe, reachedLimit } = useBasket()
  const { menuId } = useMenuMeta()

  const dispatch = useDispatch()
  const onClick = useCallback((recipeUuid) => dispatch(showDetailRecipe(recipeUuid)), [dispatch])

  const currentCollectionId = useCurrentCollectionId()
  const { setBrowserCTAVisible } = useSetBrowserCTAVisibility()
  const recipe = useRecipe(id)

  if (!recipe) {
    return null
  }

  return (
    <Slide key={id} className="embla__slide" flexGrow={0} flexShrink={0}>
      <RecipeTile
        recipe={recipe}
        currentCollectionId={currentCollectionId}
        menuId={menuId}
        onClick={onClick}
        menuPreferences={menuPreferences}
        setBrowserCTAVisible={setBrowserCTAVisible}
        canAddRecipes={canAddRecipes}
        addRecipe={addRecipe}
        removeRecipe={removeRecipe}
        reachedLimit={reachedLimit}
        isInBasket={basketHasRecipe(recipe.coreId)}
        selectVariant={() => {}}
        recipeReference=""
        originalId={recipe.coreId}
        isOutOfStock={false}
        alternativeOptions={{ optionsType: 'none', options: [] }}
      />
    </Slide>
  )
}
